import { render, staticRenderFns } from "./FontModal.vue?vue&type=template&id=df23e65c&scoped=true"
import script from "./FontModal.vue?vue&type=script&lang=js"
export * from "./FontModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df23e65c",
  null
  
)

export default component.exports